import { type DropTargetDropEvent, useDropTarget } from '@hive/component';
import type { HiveDNDData } from '@hive/core/types/dnd';
import { useI18n } from '@hive/i18n';

import { EmptyNodeChildren } from '../../layouts/empty-node-children';

export const Empty = ({
  onDrop,
  noAccessible = false,
}: {
  onDrop: (data: DropTargetDropEvent<HiveDNDData>) => void;
  noAccessible?: boolean;
}) => {
  const { dropTargetRef } = useDropTarget<HiveDNDData>(
    () => ({
      onDrop,
    }),
    [onDrop]
  );
  const t = useI18n();

  return (
    <EmptyNodeChildren ref={dropTargetRef}>
      {noAccessible
        ? t['com.hive.share-menu.option.permission.no-access']()
        : t['com.hive.rootAppSidebar.docs.no-subdoc']()}
    </EmptyNodeChildren>
  );
};
